const systemFontStack = [
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
];
export const createTypographyOptions = (tokens) => {
    const { semantic: { font: { text, title }, fontWeight, fontFamily, }, component: { button }, } = tokens;
    return {
        fontFamily: [`"${fontFamily.body.value}"`, ...systemFontStack].join(","),
        fontWeightRegular: fontWeight.regular.value,
        fontWeightMedium: fontWeight.emphasis.value,
        fontWeightBold: fontWeight.link.value,
        body1: {
            fontSize: text.body.fontSize.value,
            fontWeight: text.body.fontWeight.value,
            lineHeight: text.body.lineHeight.value,
            letterSpacing: text.body.letterSpacing.value,
        },
        body2: {
            fontSize: text.md.fontSize.value,
            fontWeight: text.md.fontWeight.value,
            lineHeight: text.md.lineHeight.value,
            letterSpacing: text.md.letterSpacing.value,
        },
        button: {
            fontSize: button.medium.fontSize.value,
            fontWeight: button.medium.fontWeight.value,
            lineHeight: button.medium.lineHeight.value,
            letterSpacing: text.body.letterSpacing.value,
            textTransform: "none",
        },
        h1: {
            fontSize: title.h1Billboard.fontSize.value,
            fontWeight: title.h1Billboard.fontWeight.value,
            lineHeight: title.h1Billboard.lineHeight.value,
            letterSpacing: title.h1Billboard.letterSpacing.value,
        },
        h2: {
            fontSize: title.h2Display.fontSize.value,
            fontWeight: title.h2Display.fontWeight.value,
            lineHeight: title.h2Display.lineHeight.value,
            letterSpacing: title.h2Display.letterSpacing.value,
        },
        h3: {
            fontSize: title.h3Lg.fontSize.value,
            fontWeight: title.h3Lg.fontWeight.value,
            lineHeight: title.h3Lg.lineHeight.value,
            letterSpacing: title.h3Lg.letterSpacing.value,
        },
        h4: {
            fontSize: title.h4Md.fontSize.value,
            fontWeight: title.h4Md.fontWeight.value,
            lineHeight: title.h4Md.lineHeight.value,
            letterSpacing: title.h4Md.letterSpacing.value,
        },
        h5: {
            fontSize: title.h5Sm.fontSize.value,
            fontWeight: title.h5Sm.fontWeight.value,
            lineHeight: title.h5Sm.lineHeight.value,
            letterSpacing: title.h5Sm.letterSpacing.value,
        },
        h6: {
            fontSize: title.h6Xs.fontSize.value,
            fontWeight: title.h6Xs.fontWeight.value,
            lineHeight: title.h6Xs.lineHeight.value,
            letterSpacing: title.h6Xs.letterSpacing.value,
        },
    };
};
//# sourceMappingURL=typography.js.map